<div class="modal-content">
    <div class="modal-status bg-success"></div>
    <div class="modal-body text-center py-4">
    <div class="modal-icon"><svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="3.5rem" height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
<path d="M9 12l2 2l4 -4"></path>
</svg></div>
      <h4 class="modal-title mb-2">SUCCESS</h4>
      <div class="text-muted" style="font-size: 1.2rem;">{{Message}}</div>
      <div class="text-muted" style="font-size: 1.0rem;" *ngIf="Message2 != null && Message2 != ''">{{Message2}}</div>
    </div>
    <div class="modal-footer">
      <div class="w-100">
        <div class="row">
          <div class="col"></div>
          <div class="col">
            <button type="button" (click)="close(true)" class="w-100 text-truncate btn btn-default btn-ok btn-success">OK</button>
          </div>
          <div class="col"></div>
        </div>
      </div>
    </div>
  </div>